// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1-7d1","footer":"Form_footer__2PbR-"};